import React from 'react';
import { ScheduleComponent, Day, Week, WorkWeek, Month, Agenda, Inject, TimelineViews, TimelineMonth, ViewsDirective, ViewDirective, ResourcesDirective, ResourceDirective } from '@syncfusion/ej2-react-schedule';
import { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";
import {
  useTheme,
  Box,
  Button,
  TextField,
  Typography,
  ButtonGroup,
  IconButton,
} from "@mui/material";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
} from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { Formik } from "formik";
import * as yup from "yup";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { ThreeDots } from "react-loader-spinner";
import axios from "axios";
import Alert from "@mui/material/Alert";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { API_BASE_URL } from "../../config";
import { useTranslation } from "react-i18next";
import "../../i18n";
import { L10n } from '@syncfusion/ej2-base';
import { loadCldr } from '@syncfusion/ej2-base';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as gregorian from 'cldr-data/main/de/ca-gregorian.json';
import * as numbers from 'cldr-data/main/de/numbers.json';
import * as timeZoneNames from 'cldr-data/main/de/timeZoneNames.json';
import { Close } from "@mui/icons-material";


loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);

const loadLocalizationData = () => {
  L10n.load({
    'de': {
      "schedule": {
        "day": "Tag",
        "week": "Woche",
        "workWeek": "Arbeitswoche",
        "month": "Monat",
        "agenda": "Agenda",
        "today": "Heute",
        "noEvents": "Keine Ereignisse",
        "emptyContainer": "Keine Termine an diesem Tag.",
        "allDay": "Ganztägig",
        "start": "Start",
        "end": "Ende",
        "more": "mehr",
        "close": "Schliessen",
        "cancel": "Abbrechen",
        "noTitle": "(Kein Titel)",
        "delete": "Löschen",
        "deleteEvent": "Ereignis löschen",
        "deleteMultipleEvent": "Mehrere Ereignisse löschen",
        "selectedItems": "Artikel ausgewählt",
        "deleteSeries": "Serie löschen",
        "edit": "Bearbeiten",
        "editSeries": "Serie bearbeiten",
        "editEvent": "Ereignis bearbeiten",
        "createEvent": "Erstellen",
        "subject": "Betreff",
        "addTitle": "Titel hinzufügen",
        "moreDetails": "Mehr Details",
        "save": "Speichern",
        "editContent": "Möchten Sie nur dieses Ereignis oder die gesamte Serie bearbeiten?",
        "deleteRecurrenceContent": "Möchten Sie nur dieses Ereignis oder die gesamte Serie löschen?",
        "deleteContent": "Möchten Sie dieses Ereignis wirklich löschen?",
        "deleteMultipleContent": "Möchten Sie die ausgewählten Ereignisse wirklich löschen?",
        "newEvent": "Neues Ereignis",
        "title": "Titel",
        "location": "Ort",
        "description": "Beschreibung",
        "timezone": "Zeitzone",
        "startTimezone": "Start-Zeitzone",
        "endTimezone": "End-Zeitzone",
        "repeat": "Wiederholen",
        "saveButton": "Speichern",
        "cancelButton": "Abbrechen",
        "deleteButton": "Löschen",
        "recurrence": "Wiederholung",
        "wrongPattern": "Das Wiederholungsmuster ist nicht gültig.",
        "seriesChangeAlert": "Die Änderungen an bestimmten Instanzen dieser Serie werden abgebrochen und diese Ereignisse entsprechen wieder der Serie.",
        "createError": "Die Dauer des Ereignisses muss länger sein als die Häufigkeit, mit der es auftritt. Verkürzen Sie die Dauer oder ändern Sie das Wiederholungsmuster im Ereignis-Editor.",
        "recurrenceDateValidation": "Einige Monate haben weniger als das ausgewählte Datum. Für diese Monate fällt das Ereignis auf den letzten Tag des Monats.",
        "sameDayAlert": "Zwei Vorkommen desselben Ereignisses können nicht am selben Tag stattfinden.",
        "editRecurrence": "Wiederholung bearbeiten",
        "repeats": "Wiederholt sich",
        "alert": "Achtung",
        "startEndError": "Das ausgewählte Enddatum tritt vor dem Startdatum auf.",
        "invalidDateError": "Der eingegebene Datumswert ist ungültig.",
        "ok": "OK",
        "occurrence": "Auftreten",
        "series": "Serie",
        "previous": "Vorherige",
        "next": "Nächste",
        "timelineDay": "Zeitleiste Tag",
        "timelineWeek": "Zeitleiste Woche",
        "timelineWorkWeek": "Zeitleiste Arbeitswoche",
        "timelineMonth": "Zeitleiste Monat"
      }
    },
    'en': {
      "schedule": {
        "day": "Day",
        "week": "Week",
        "workWeek": "Work Week",
        "month": "Month",
        "agenda": "Agenda",
        "today": "Today",
        "noEvents": "No events",
        "emptyContainer": "No appointments on this day.",
        "allDay": "All day",
        "start": "Start",
        "end": "End",
        "more": "more",
        "close": "Close",
        "cancel": "Cancel",
        "noTitle": "(No title)",
        "delete": "Delete",
        "deleteEvent": "Delete event",
        "deleteMultipleEvent": "Delete multiple events",
        "selectedItems": "Selected items",
        "deleteSeries": "Delete series",
        "edit": "Edit",
        "editSeries": "Edit series",
        "editEvent": "Edit event",
        "createEvent": "Create event",
        "subject": "Subject",
        "addTitle": "Add title",
        "moreDetails": "More details",
        "save": "Save",
        "editContent": "Do you want to edit only this event or the entire series?",
        "deleteRecurrenceContent": "Do you want to delete only this event or the entire series?",
        "deleteContent": "Are you sure you want to delete this event?",
        "deleteMultipleContent": "Are you sure you want to delete the selected events?",
        "newEvent": "New event",
        "title": "Title",
        "location": "Location",
        "description": "Description",
        "timezone": "Time zone",
        "startTimezone": "Start timezone",
        "endTimezone": "End timezone",
        "repeat": "Repeat",
        "saveButton": "Save",
        "cancelButton": "Cancel",
        "deleteButton": "Delete",
        "recurrence": "Recurrence",
        "wrongPattern": "The recurrence pattern is not valid.",
        "seriesChangeAlert": "Changes made to specific instances of this series will be cancelled and those events will match the series again.",
        "createError": "The duration of the event must be longer than how often it occurs. Shorten the duration or change the recurrence pattern in the event editor.",
        "recurrenceDateValidation": "Some months have fewer than the selected date. For these months, the event falls on the last day of the month.",
        "sameDayAlert": "Two occurrences of the same event cannot occur on the same day.",
        "editRecurrence": "Edit recurrence",
        "repeats": "Repeats",
        "alert": "Alert",
        "startEndError": "The selected end date occurs before the start date.",
        "invalidDateError": "The entered date value is invalid.",
        "ok": "OK",
        "occurrence": "Occurrence",
        "series": "Series",
        "previous": "Previous",
        "next": "Next",
        "timelineDay": "Timeline Day",
        "timelineWeek": "Timeline Week",
        "timelineWorkWeek": "Timeline Work Week",
        "timelineMonth": "Timeline Month"
      }
    }
  });
  };

const Shiftplan = ({ availability }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const [shiftPlanData, setShiftPlanData] = useState({});
    const [timereqData, setTimeReqData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [weekAdjustment, setWeekAdjustment] = useState(0);
    const token = localStorage.getItem("session_token");
    const { t, i18n } = useTranslation();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [departmentData, setDepartmentData] = useState([]);
    const [view, setView] = useState("day");
    const [shifts, setShifts] = useState([]);
    const [openingHours, setOpeningHours] = useState({});
    const [currentDay, setCurrentDay] = useState(new Date());
    const [open, setOpen] = useState(false);
    const closeModal = () => setOpen(false);
    const [currentWeekNum, setCurrentWeekNum] = useState();
    const [selectedStartWeek, setSelectedStartWeek] = useState();
    const [selectedEndWeek, setSelectedEndWeek] = useState();
    const [mondayDate, setMondayDate] = useState();
    const lightGreyColor = '#A9A9A9';

  
    useEffect(() => {
      const fetchShiftPlan = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(`${API_BASE_URL}/api/scheduler`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
    
          const formattedTimeReqData = Object.values(response.data.timereq_data).flat().map(item => ({
            Id: item.id,
            Subject: item.worker_count,
            StartTime: new Date(new Date(item.start_time).getTime() - 120 * 60 * 1000),
            EndTime: new Date(new Date(item.end_time).getTime() - 120 * 60 * 1000),
            department: item.department,
          }));
    

          const updatedDepartmentData = [...response.data.department_list_overview, { id: 'diff', department: 'Differenz', color: '#FF6347' }]
            .map(dept => {
              let color = dept.color || '';
              if (dept.department !== "Differenz") {
                color = lightGreyColor; // all departments light grey except "Differenz"
              }
          
              return {
                ...dept,
                color: color
              };
            });
    
          setTimeReqData(formattedTimeReqData);
          setDepartmentData(updatedDepartmentData);
    
          setIsLoading(false);
        } catch (error) {
          console.error("Error fetching shift plan data:", error);
          setIsLoading(false);
        }
      };
    
      fetchShiftPlan();
    }, [token]);

    useEffect(() => {
      loadLocalizationData();
    }, [i18n.language]);

    
  const eventRendered = (args) => {
    // Prüfen, ob das Ereignis zur "Differenz"-Kategorie gehört und die Differenz ungleich Null ist
    if (args.data.department === 'Differenz') {
      if (args.data.Subject !== 0) {
        args.element.style.backgroundColor = 'red'; // Die Farbe Rot, wenn die Differenz ungleich Null ist
      } else {
        args.element.style.backgroundColor = 'green'; // Die Farbe Grün, wenn die Differenz gleich Null ist
      }
    }
  };


  const resourceHeaderTemplate = (props) => {
    return (
      <div className="template-wrap">
        <div className="department">{props.resourceData.department}</div>
      </div>
    );
  };

  const eventTemplate = (props) => {
    return (
      <div 
        style={{
          display: 'flex',
          justifyContent: 'center', // Horizontally center the content
          alignItems: 'center', // Vertically center the content
          height: '100%', // Take full height of the event field
          width: '100%', // Ensure the container takes full width
          textAlign: 'center', // Center the text
        }}>
          <span>{props.Subject}</span>
          {/* Remove or comment out any unwanted fields like time */}
      </div>
    );
  };

  const onPopupOpen = (args) => {
    args.cancel = true;
  };

  const eventClick = (args) => {
    args.cancel = true; // Prevent default click action
  };

  const renderResourceDirectives = () => {
    return departmentData.map((dept, index) => (
        <ResourceDirective 
            key={index}
            field='department' 
            title='Department' 
            name='Departments' 
            dataSource={[dept]}
            textField='department' 
            idField='department' 
            colorField='color' // Use 'color' as it is now part of your data
        />
    ));
  };

  if (isLoading) {
    return (
      <Box
        boxSizing="border-box"
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        p="20px"
      >
        <ThreeDots type="ThreeDots" color="#70D8BD" height={80} width={80} />
      </Box>
    );
  }

  return (
    <div>
        <ScheduleComponent 
            width='100%' 
            height='80vh' 
            selectedDate={new Date()} 
            currentView='TimelineWeek' 
            eventSettings={{ dataSource: timereqData, template: eventTemplate }}
            resourceHeaderTemplate={resourceHeaderTemplate} 
            allowDragAndDrop={false}
            allowEditing={false}
            allowInline={false}
            showQuickInfo={false}
            eventClick={eventClick}
            onPopupOpen={onPopupOpen}
            group={{ resources: ['Departments'] }}
            locale={i18n.language}
            eventRendered={eventRendered}
            firstDayOfWeek={1}
        >
    <ResourcesDirective>
    <ResourcesDirective>
        {renderResourceDirectives()}
    </ResourcesDirective>
    <ResourceDirective 
            field='department' 
            title='Department' 
            name='Departments' 
            dataSource={departmentData}
            textField='department' 
            idField='department' 
            colorField='color' 
        />
    </ResourcesDirective>
    <ViewsDirective>
    <ViewDirective option='TimelineWeek' />
    </ViewsDirective>
    <Inject services={[TimelineViews]} />
    </ScheduleComponent>
    </div>
    );
};

export default Shiftplan;
